module.exports = __webpack_public_path__ + "media/images/logo-11a1613c5c16b0b88d3336f1fa7ddf8e.svg";